import {ref} from "vue";
import {useLog} from "@/composables/useLog";
import {authFetch} from "@/composables/useAuthFetch";

const log = useLog("useSaveAffiliation");

async function refreshClerkUser(user) {
  try {
    await window.Clerk?.session?.touch();
    await user.reload();
  } catch (error) {
    log(`refresh failed: ${error?.message}`);
  }
}

async function postAffiliation(user, affiliation, country) {
  const body = {
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    publicMetadata: {affiliation: affiliation || "", country: country || ""},
    overwrite: true,
  };
  const response = await authFetch("/api/v1/user/update/clerk", {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify(body),
  });
  const data = await response.json();
  return data.ok === true;
}

export function useSaveAffiliation() {
  const isSaving = ref(false);

  async function save(user, affiliation, country) {
    if (!user) return false;
    isSaving.value = true;
    try {
      const ok = await postAffiliation(user, affiliation, country);
      log(`save result: ok=${ok}`);
      if (ok) await refreshClerkUser(user);
      return ok;
    } catch (error) {
      log(`save error: ${error?.message}`);
      return false;
    } finally {
      isSaving.value = false;
    }
  }

  return {isSaving, save};
}
